import {EntityType} from './EntityType';

/**
 * Contains all known image types.
 */
export enum ImageType {
  Club = 'club',
  Competition = 'competition',
  District = 'district',
  Team = 'team',
  User = 'user',
  Contact = 'contact',
  Player = 'player',
  Referee = 'referee',
  RefereeGroup = 'referee-group',
  Cobranding = 'cobranding',
  CobrandingWhite = 'cobranding-white',
  Video = 'video',
  MatchEvent = 'match-event',
  Venue = 'venue',
  Gallery = 'gallery',
  TeamImage = 'team-image',
  News = 'news',
  Reward = 'reward',
  MatchEmbedding = 'match-embedding'
}

export namespace ImageType {
  /**
   * Converts the image type to the more generic entity type. Note, that this mapping
   * is not supported for every image type!
   */
  function toEntityType(imageType: ImageType): EntityType {
    if (imageType === ImageType.Player) {
      return EntityType.Profile;
    }

    if (!EntityType[imageType]) {
      throw new Error(`No mapping to entity type defined for image type ${imageType}`);
    }

    return EntityType[imageType];
  }
}
